import { Layout } from 'antd';
import styled from 'styled-components';

export const StyledSider = styled(Layout.Sider)`
  ul {
    height: 100%;
    width: 100%;
  }
`;
